const BursarySupport = () => {
  return (
    <section data-testid="bursary-section" className="py-20 bg-[var(--ac-royal)] text-white relative overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.18] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 15% 20%, rgba(245,192,86,0.4) 0, transparent 40%), radial-gradient(circle at 85% 80%, rgba(162,29,35,0.5) 0, transparent 45%)",
        }}
      />
      <div className="ac-container relative z-10 text-center max-w-3xl">
        <div className="eyebrow on-dark">Financial Support</div>
        <h2
          className="section-heading on-dark mt-3"
          data-testid="bursary-heading"
        >
          Variety of Funding Options
        </h2>
        <p className="mt-5 text-white/90 text-[16px] md:text-[17px] leading-relaxed">
          Our bursary programs help reduce tuition costs, making education more
          accessible so you can focus on building your future with confidence.
        </p>
        <div className="mt-8">
          <a
            href="/financial-aid"
            className="ds-btn ds-btn--primary"
            data-testid="bursary-explore-btn"
          >
            Explore Options
          </a>
        </div>
      </div>
    </section>
  );
};

export default BursarySupport;
